export const getCookie = (name: string): string | undefined => {
  if (typeof document === 'undefined') {
    return undefined
  }
  const prefix = `${encodeURIComponent(name)}=`
  const match = document.cookie.split('; ').find((c) => c.startsWith(prefix))
  return match ? decodeURIComponent(match.slice(prefix.length)) : undefined
}

export const setCookie = (name: string, value: string, options: { expires?: Date } = {}) => {
  if (typeof document === 'undefined') {
    return
  }
  const expires = options.expires ? `; expires=${options.expires.toUTCString()}` : ''
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/`
}

export const removeCookie = (name: string) => {
  setCookie(name, '', { expires: new Date(0) })
}
